import { observer } from 'mobx-react-lite'
import { EnterNumberCommon } from 'pages/settings/ui/EnterNumberCommon'
import { useTextEnableLandlineContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineContext'

export const EnterNumber = observer(() => {
  const { enterNumberStore, nextClickHandler } = useTextEnableLandlineContext()
  return <EnterNumberCommon store={enterNumberStore} nextClickHandler={nextClickHandler} />
})
